<script setup>
import ClipboardGroupGrid from '@/components/sale/ClipboardGroupGrid.vue'
</script>
<template>
  <clipboard-group-grid />
</template>
